import * as React from 'react';
export const clicktopaySvg = React.forwardRef(function clicktopaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.39 3.132a.58.58 0 0 1 .815.077l3.662 4.423a.576.576 0 0 1 0 .735l-3.662 4.423a.578.578 0 0 1-.446.21H9.06a.58.58 0 0 1-.573-.649.576.576 0 0 1 .128-.295L11.973 8 8.788 4.154H7.631l3.022 3.468a.576.576 0 0 1 0 .756L7.26 12.273a2.121 2.121 0 0 1-1.6.727H2.121a2.123 2.123 0 0 1-1.5-.62A2.113 2.113 0 0 1 0 10.885v-5.77c0-.56.223-1.099.621-1.495.398-.397.937-.62 1.5-.62h2.12a.579.579 0 0 1 .578.577.576.576 0 0 1-.578.577h-2.12a.965.965 0 0 0-.964.961v5.77a.96.96 0 0 0 .963.961h3.54a.967.967 0 0 0 .727-.33L9.45 8 5.925 3.955A.576.576 0 0 1 6.361 3h2.7c.172 0 .335.077.445.21l3.663 4.423a.576.576 0 0 1 0 .734l-2.88 3.48h1.197L14.671 8l-3.358-4.056a.576.576 0 0 1 .078-.812Z',
    }),
  );
});
clicktopaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var clicktopay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'clicktopay',
  svg: clicktopaySvg,
};
